<script setup lang="ts">
  import { ChevronsDownUp, ChevronsUpDown } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";

  withDefaults(defineProps<{ expanded?: boolean }>(), { expanded: false });

  const emit = defineEmits<{ toggle: [] }>();
</script>

<template>
  <Button
    variant="outline"
    @click="emit('toggle')">
    <ChevronsDownUp
      v-if="expanded"
      class="h-4 w-4" />
    <ChevronsUpDown
      v-else
      class="h-4 w-4" />
    {{ expanded ? "Collapse all" : "Expand all" }}
  </Button>
</template>
